import * as ContractServices from "../../helpers/services/ContractServices";
import * as CompanyServices from "../../helpers/services/CompanyServices";
import { receiveErrors } from "../error/error.actions";
import CompanyActionTypes from "./company.types";

const setIsFetching = () => ({
  type: CompanyActionTypes.RETRIEVE_COMPANIES,
  payload: { isFetching: true },
});

const setIsDetailsFetching = () => ({
  type: CompanyActionTypes.RETRIEVE_COMPANIES,
  payload: { isDetailsFetching: true },
});
const _retrieveCompanies = (companies) => ({
  type: CompanyActionTypes.RETRIEVE_COMPANIES,
  payload: { companiesList: companies, isFetching: false },
});

export const retrieveCompanies = () => async (dispatch) => {
  dispatch(setIsFetching());
  try {
    const response = await CompanyServices.getCompanies();
    return dispatch(_retrieveCompanies(response));
  } catch (error) {
    // dispatch(setSessionValidated(false));
    return dispatch(receiveErrors(error));
  }
};

// export const retrieveCompany = companyId => async dispatch =>{
//   console.log("here")
//   dispatch(setIsDetailsFetching());
//   try{
//     const response = await CompanyServices.getCompany({companyId});
//     console.log("*****************8")
//     console.log(response);
//     dispatch(selectCompany(response));
//   }
//   catch(error){
//     return dispatch(receiveErrors(error));
//   }
// }
export const retrieveCompanySubsidiaries = (companyId) => async (dispatch) => {
  dispatch(setIsDetailsFetching());
  try {
    const response = await CompanyServices.getCompanySubsidiaries(companyId);
    return dispatch({
      type: CompanyActionTypes.RETRIEVE_COMPANY_DETAILS,
      payload: { subsidiaries: response },
    });
  } catch (error) {
    // dispatch(setSessionValidated(false));
    return dispatch(receiveErrors(error));
  }
};

export const retrieveCompanyAddresses = (companyId) => async (dispatch) => {
  console.log("here");
  dispatch(setIsDetailsFetching());
  try {
    console.log("here");
    const response = await CompanyServices.getCompanyAddresses(companyId);
    return dispatch({
      type: CompanyActionTypes.RETRIEVE_COMPANY_DETAILS,
      payload: { addresses: response },
    });
  } catch (error) {
    // dispatch(setSessionValidated(false));
    return dispatch(receiveErrors(error));
  }
};

export const retrieveCompanyAppendices = (contractId) => async (dispatch) => {
  dispatch(setIsDetailsFetching());
  try {
    const response = await ContractServices.getContractAppendices(contractId);
    return dispatch({
      type: CompanyActionTypes.RETRIEVE_COMPANY_DETAILS,
      payload: { appendices: response },
    });
  } catch (error) {
    // dispatch(setSessionValidated(false));
    return dispatch(receiveErrors(error));
  }
};

export const selectCompany = (company) => ({
  type: CompanyActionTypes.RETRIEVE_COMPANIES,
  payload: { selectedCompany: company },
});
